<!--<app-loader [loader]="loader.count" *ngIf="loader.count > 0"></app-loader>-->

<app-header></app-header>

<div class="mapBlock container main-container h-25"
     [ngStyle]="{ 'background-image': catalogueService.getProperty('imageBackground') ? 'url(' + catalogueService.getProperty('imageBackground') + ')' : 'none' }">
    <loader-throbber *ngIf="loader.count > 0"></loader-throbber>
  <app-menu-tabs [filter]="'ONLY_MAPS'"></app-menu-tabs>

  <!--{{ load maps }}-->
  <div class="map-item-wrapper container">
    <div class="theMap" id="the-map">
      <iframe class="mapFrame" [src]="sanitizedUrl"></iframe>
    </div>
  </div>

</div>

<app-footer></app-footer>
